
import { NgxSpinnerService } from 'ngx-spinner';
import { Form } from 'src/app/models/form.model';
import { MatDialog, MatDialogRef, MatSnackBar, MatPaginator, PageEvent } from '@angular/material';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { ToastrService } from 'ngx-toastr';
//import Swal from 'sweetalert2';
declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-borradores',
  templateUrl: './borradores.component.html',
  styleUrls: ['./borradores.component.css'],
  providers: [UserService]
})
export class BorradoresComponent implements OnInit {
  @ViewChild('openModal') openModal: TemplateRef<any>;

  formulario
  // data
  borradores: any[] = [];
  borradoresFiltrados: any[] = [];
  pagedBorradores: any[] = [];

  // búsqueda
  filtro = '';

  // crear
  creating = false;
  nuevoNombre = '';
  formulariofinal;

  displayedColumns = ['name', 'form', 'actions'];
  // paginación
  pageIndex = 0;
  pageSize = 5;
  pageSizeOptions = [5, 8, 15, 25];

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<BorradoresComponent>,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this._userService.getDrafts().subscribe(
      response => {
        this.borradores = response.borradores;
        this.filtrar(); // <- llena filtrados + paginados
      },
      error => {
        console.log(error);
        this.toastr.error('No se pudieron obtener los borradores.', 'Error');
      }
    );
  }

  loadDraft(borrador) {
    this.spinner.show();
    localStorage.clear();
    this._userService.getDraft(borrador.id).subscribe(
      response => {
        if (response.info.Permisos) localStorage.setItem("Permisos", JSON.stringify(response.info.Permisos));
        if (response.info.adjuntos) localStorage.setItem("adjuntos", JSON.stringify(response.info.adjuntos));
        if (response.info.ampliacion) localStorage.setItem("ampliacion", JSON.stringify(response.info.ampliacion));
        if (response.info.antecedentes) localStorage.setItem("antecedentes", JSON.stringify(response.info.antecedentes));
        if (response.info.antecedentesPrevios) localStorage.setItem("antecedentesPrevios", JSON.stringify(response.info.antecedentesPrevios));
        if (response.info.antecedentes_edif) localStorage.setItem("antecedentes_edif", JSON.stringify(response.info.antecedentes_edif));
        if (response.info.aporte) localStorage.setItem("tipo_autorizacion", JSON.stringify(response.info.aporte));
        if (response.info.arquitectos) localStorage.setItem("arquitectos", JSON.stringify(response.info.arquitectos));
        if (response.info.autorizaciones) localStorage.setItem("autorizaciones", JSON.stringify(response.info.autorizaciones));
        if (response.info.calculistaProfesional) localStorage.setItem("calculistaProfesional", JSON.stringify(response.info.calculistaProfesional));
        if (response.info.calculistas) localStorage.setItem("calculistas", JSON.stringify(response.info.calculistas));
        if (response.info.calculoAcumulado) localStorage.setItem("calculoAcumulado", JSON.stringify(response.info.calculoAcumulado));
        if (response.info.caract_anteproyecto_obranueva) localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify(response.info.caract_anteproyecto_obranueva));
        if (response.info.caracteristica_proyecto) localStorage.setItem("caracteristica_proyecto", JSON.stringify(response.info.caracteristica_proyecto));
        if (response.info.clasificacion) localStorage.setItem("clasificacion", JSON.stringify(response.info.clasificacion));
        if (response.info.constructora) localStorage.setItem("constructora", JSON.stringify(response.info.constructora));
        if (response.info.constructoraProfesional) localStorage.setItem("constructoraProfesional", JSON.stringify(response.info.constructoraProfesional));
        if (response.info.constructores) localStorage.setItem("constructores", JSON.stringify(response.info.constructores));
        if (response.info.cuentaRevisor) localStorage.setItem("cuentaRevisor", JSON.stringify(response.info.cuentaRevisor));
        if (response.info.cuentaRevisorCalculo) localStorage.setItem("cuentaRevisorCalculo", JSON.stringify(response.info.cuentaRevisorCalculo));
        if (response.info.declaracion) localStorage.setItem("declaracion", JSON.stringify(response.info.declaracion));
        if (response.info.disposiciones_esp) localStorage.setItem("disposiciones_esp", JSON.stringify(response.info.disposiciones_esp));
        if (response.info.empresas) localStorage.setItem("empresas", JSON.stringify(response.info.empresas));
        if (response.info.forma_cumpl) localStorage.setItem("forma_cumpl", JSON.stringify(response.info.forma_cumpl));
        if (response.info.incentivos) localStorage.setItem("incentivos", JSON.stringify(response.info.incentivos));
        if (response.info.independiente) localStorage.setItem("independiente", JSON.stringify(response.info.independiente));
        if (response.info.informacionPropiedad) localStorage.setItem("informacionPropiedad", JSON.stringify(response.info.informacionPropiedad));
        if (response.info.inspectorObra) localStorage.setItem("inspectorObra", JSON.stringify(response.info.inspectorObra));
        if (response.info.inspectorProfesional) localStorage.setItem("inspectorProfesional", JSON.stringify(response.info.inspectorProfesional));
        if (response.info.normas_urbanisticas) localStorage.setItem("normas_urbanisticas", JSON.stringify(response.info.normas_urbanisticas));
        if (response.info.otrasSolicitudesAcomp) localStorage.setItem("otrasSolicitudesAcomp", JSON.stringify(response.info.otrasSolicitudesAcomp));
        if (response.info.permiso_anteriores) localStorage.setItem("permiso_anteriores", JSON.stringify(response.info.permiso_anteriores));
        if (response.info.permiso_original) localStorage.setItem("permiso_original", JSON.stringify(response.info.permiso_original));
        if (response.info.personeria) localStorage.setItem("personeria", JSON.stringify(response.info.personeria));
        if (response.info.porcentaje_finalCesion) localStorage.setItem("porcentaje_finalCesion", JSON.stringify(response.info.porcentaje_finalCesion));
        if (response.info.propiedad) localStorage.setItem("propiedad", JSON.stringify(response.info.propiedad));
        if (response.info.propietarioRepresentante) localStorage.setItem("propietarioRepresentante", JSON.stringify(response.info.propietarioRepresentante));
        if (response.info.propietarios) localStorage.setItem("propietarios", JSON.stringify(response.info.propietarios));
        if (response.info.protecciones_esp) localStorage.setItem("protecciones_esp", JSON.stringify(response.info.protecciones_esp));
        if (response.info.proyecto) localStorage.setItem("proyecto", JSON.stringify(response.info.proyecto));
        if (response.info.representantes) localStorage.setItem("representantes", JSON.stringify(response.info.representantes));
        if (response.info.revisor) localStorage.setItem("revisor", JSON.stringify(response.info.revisor));
        if (response.info.revisorCalculo) localStorage.setItem("revisorCalculo", JSON.stringify(response.info.revisorCalculo));
        if (response.info.revisorProfesional) localStorage.setItem("revisorProfesional", JSON.stringify(response.info.revisorProfesional));
        if (response.info.superficie) localStorage.setItem("superficie", JSON.stringify(response.info.superficie));
        if (response.info.superficieDestino) localStorage.setItem("superficieDestino", JSON.stringify(response.info.superficieDestino));
        if (response.info.superficieSobre) localStorage.setItem("superficieSobre", JSON.stringify(response.info.superficieSobre));
        if (response.info.superficieSubterraneo) localStorage.setItem("superficieSubterraneo", JSON.stringify(response.info.superficieSubterraneo));
        if (response.info.superficie_anteproyecto) localStorage.setItem("superficie_anteproyecto", JSON.stringify(response.info.superficie_anteproyecto));
        if (response.info.tipo_solicitud) localStorage.setItem("tipo_solicitud", JSON.stringify(response.info.tipo_solicitud));
        if (response.info.unidades) localStorage.setItem("unidades", JSON.stringify(response.info.unidades));
        if (response.info.uso_suelo) localStorage.setItem("uso_suelo", JSON.stringify(response.info.uso_suelo));
        if (response.info.ZipURL) localStorage.setItem("ZipURL", JSON.stringify(response.info.ZipURL));
        if (response.info.antecedentes_status) localStorage.setItem("antecedentes_status", JSON.stringify(response.info.antecedentes_status));
        if (response.info.archivos_marcados) localStorage.setItem("archivos_marcados", JSON.stringify(response.info.archivos_marcados));
        if (response.info.form) localStorage.setItem("form", JSON.stringify(response.info.form));
        if (response.info.formTitle) localStorage.setItem("formTitle", JSON.stringify(response.info.formTitle));
        if (response.info.tipoPersonaPropietario) localStorage.setItem("tipoPersonaPropietario", JSON.stringify(response.info.tipoPersonaPropietario));

        this.getForm(response.form, borrador.title);
        this.dialogRef.close()
        this.spinner.hide();
      },
      error => { console.log(error); this.spinner.hide(); }
    );
  }

  trackById(_i: number, b: any) {
    return (b && b.draftId && b.draftId._id) || (b && b._id) || _i;
  }

  getName(b: any): string {
    return (b && b.draftId && b.draftId.name) || b.title || b.name || 'Sin nombre';
  }
  getFormCode(b: any): string {
    return (b && b.draftId && b.draftId.form) || b.form || '';
  }
  getForm(id, title) {
    this.store.dispatch(new FormActions.FormUpdate(id, title))
    localStorage.setItem("form", id)
    this.toastr.success(`Borrador “${title}” cargado correctamente.`, 'Exito');

  }
  getLegacyDraft(b: any): { id: string, title: string } {
    const id = (b && b.draftId && b.draftId._id) || b.id || b._id;
    return { id, title: this.getName(b) };
  }

  // búsqueda + paginación
  filtrar() {
    const q = (this.filtro || '').toLowerCase().trim();
    this.borradoresFiltrados = !q
      ? this.borradores.slice()
      : this.borradores.filter(b => this.getName(b).toLowerCase().includes(q));

    this.pageIndex = 0;
    this.updatePaged();
  }
  onPage(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.updatePaged();
  }
  private updatePaged() {
    const start = this.pageIndex * this.pageSize;
    this.pagedBorradores = this.borradoresFiltrados.slice(start, start + this.pageSize);
  }
  clearSearch() { this.filtro = ''; this.filtrar(); }
  startCreate() {
    this.formulario = localStorage.getItem("form");
    if (this.formulario) { this.creating = true; } else {
      this.toastr.warning('Primero debes seleccionar un formulario para poder crear un nuevo borrador.', 'Advertencia');
    }
  }
  cancelCreate() { this.creating = false; this.nuevoNombre = ''; }
  createDraft() {
    if (!this.nuevoNombre || this.nuevoNombre.length < 3) { return; }
    this.formulariofinal = this.allStorage();
    this._userService.saveDraft(this.nuevoNombre, this.formulariofinal).subscribe(
      _ => {
        this.nuevoNombre = '';
        this.creating = false;
        this.refresh();
        this.toastr.success(`Borrador “${this.nuevoNombre}” creado correctamente.`, 'Éxito');

      },
      err => {
        console.log(err)
        this.toastr.error('No se pudo guardar el borrador.', 'Error');
      }
    );
  }

  allStorage() {

    return Object.keys(localStorage)
      .reduce((obj, k) => {
        if (k == 'form' || k == 'formId' || k == 'formTitle' || k == 'ZipURL' || k == 'formIdOK' || k == 'tipo_solOK' || k == 'docs_checkedOK' || k == 'docs_checked' || k == 'archivos_marcados' || k == 'antecedentes_status') {// para que 3.10 llegue completo  
          return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? localStorage.getItem(k) : '' }
        } else {
          return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? JSON.parse(localStorage.getItem(k)) : '' }
        }
      }, {});
  }

  deleteDraft(b: any) {
    const name = this.getName(b);
    const id = (b && b.draftId && b.draftId._id) || b.id || b._id;

    const ref = this.dialog.open(this.openModal, {
      width: '420px',
      data: {
        title: 'Eliminar borrador',
        message: `¿Esta seguro de eliminar el borrador “${this.getName(b)}”?`,
        emphasis: 'Esta acción no se puede deshacer.',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        idDraft: id
      }
    });
  }

  delete(id) {
    console.log(id);
    
    this._userService.deleteDraft(id).subscribe(
      _ => {
        this.dialog.closeAll()
        this.refresh();
        this.toastr.success('Borrador eliminado exitosamente', 'Éxito');
      },
      err => {
        this.dialog.closeAll()
        console.log(err);
        this.toastr.error('No se pudo eliminar el borrador.', 'Error');
      }
    );
  }

  private refresh() {
    this._userService.getDrafts().subscribe(
      response => { this.borradores = response.borradores; this.filtrar(); },
      error => console.log(error)
    );
  }

}

